/**
 * OpenCode config writer
 *
 * Skill: ~/.agents/skills/sailfish-autofix/ (cross-client)
 * MCP: ~/.config/opencode/config.json mcpServers.sailfishAutofix
 */

import { homedir } from "os";
import { join } from "path";
import type { AgentConfigWriter } from "./base.js";
import { installCrossClientSkill, removeCrossClientSkill, buildMcpEntry, mutateJsonFile } from "./base.js";
import { MCP_SERVER_NAME } from "../constants.js";

const OPENCODE_CONFIG = join(homedir(), ".config", "opencode", "config.json");

export const opencode: AgentConfigWriter = {
  id: "opencode",
  name: "OpenCode",

  installSkill(global: boolean) {
    installCrossClientSkill(global);
  },

  installMcp() {
    mutateJsonFile(OPENCODE_CONFIG, (config) => {
      if (!config.mcpServers) config.mcpServers = {};
      config.mcpServers[MCP_SERVER_NAME] = buildMcpEntry();
      return config;
    });
  },

  uninstallSkill() {
    removeCrossClientSkill(true);
  },

  uninstallMcp() {
    mutateJsonFile(OPENCODE_CONFIG, (config) => {
      if (config.mcpServers?.[MCP_SERVER_NAME]) {
        delete config.mcpServers[MCP_SERVER_NAME];
      }
      return config;
    }, false);
  },
};
